
import React, { useState, useEffect, useRef } from 'react';
import { View, Text, Button, Collection } from "@aws-amplify/ui-react";



const generateQuestions = (numQuestions) => {
    const questions = [];
    for (let i = 0; i < numQuestions; i++) {
        const num1 = Math.floor(Math.random() * 12) + 1;
        const num2 = Math.floor(Math.random() * 12) + 1;
        questions.push({
            question: `${num1} x ${num2}`,
            answer: num1 * num2,
        });
    }
    return questions;
};

const ArithmeticPractice = ({ numQuestions = 25, onRestart }) => {
    const [questions, setQuestions] = useState([]);
    const [userAnswers, setUserAnswers] = useState([]);
    const [quizSubmitted, setQuizSubmitted] = useState(false);
    const [score, setScore] = useState(0);
    const [elapsedTime, setElapsedTime] = useState(0);
    const timerRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(1);
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setUserAnswers([]);
    };

    useEffect(() => {
        setQuestions(generateQuestions(numQuestions));
    }, [numQuestions]);

    useEffect(() => {
        if (!quizSubmitted) {
            timerRef.current = setInterval(() => {
                setElapsedTime(prevTime => prevTime + 1);
            }, 1000);
        } else {
            clearInterval(timerRef.current);
        }
        return () => clearInterval(timerRef.current);
    }, [quizSubmitted]);

    const handleAnswer = (index, answer) => {
        const newAnswers = [...userAnswers];
        newAnswers[index] = answer;
        setUserAnswers(newAnswers);
    };

    const submitQuiz = () => {
        let newScore = 0;
        questions.forEach((q, index) => {
            if (q.answer === userAnswers[index]) {
                newScore += 1;
            }
        });
        setScore(newScore);
        setQuizSubmitted(true);
    };

    const restartQuiz = () => {
        setQuestions(generateQuestions(numQuestions));
        setUserAnswers([]);
        setQuizSubmitted(false);
        setScore(0);
        setElapsedTime(0);
        if (onRestart) onRestart();
    };

    return (
        <View padding="large">
            <Text>Arithmetic Practice</Text>
            <Text>Elapsed Time: {elapsedTime} seconds</Text>
            {quizSubmitted ? (
                <>
                    <Text>Your score: {score} / {questions.length}</Text>
                    {/*<Text>Duration: {elapsedTime} seconds</Text>*/}
                    <Collection
                        items={questions}
                        type="grid"
                        direction="row"
                        wrap="wrap"
                        gap="20px"
                        // isPaginated = {false}
                        // itemsPerPage={25}
                        templateColumns={questions.length > 10 ? "repeat(5, 1fr)" : "1fr"}
                    >
                        {({ question, answer }, index) => (
                            <View key={index} style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '5px' }}>
                                <Text>{question} = {answer} (Your answer: {userAnswers[index]})</Text>
                                <Text style={{ color: userAnswers[index] === answer ? 'green' : 'red' }}>
                                    {userAnswers[index] === answer ? 'Correct' : `Incorrect, correct answer is ${answer}`}
                                </Text>
                            </View>
                        )}
                    </Collection>

                    <Button onClick={restartQuiz}>Restart</Button>
                </>
            ) : (
                <View>
                    <Collection
                        items={questions}
                        type="grid"
                        direction="row"
                        wrap="wrap"
                        gap="20px"
                        // isPaginated
                        itemsPerPage={25}
                        onPageChange={
                            console.log("You have reached the end of the quiz")

                        }
                        templateColumns={questions.length > 10 ? "repeat(5, 1fr)" : "1fr"}
                    >
                        {({ question }, index) => (
                            <View key={index} style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '5px' }}>
                                <Text
                                    style={{
                                        fontSize: '18px',
                                        marginBottom: '10px',
                                        alignContent: 'center'
                                    }}
                                >{question}</Text>
                                <input
                                    type="number"
                                    value={userAnswers[index] || ''}
                                    onChange={(e) => handleAnswer(index, Number(e.target.value))}
                                    style={{
                                        fontSize: '16px',
                                        alignContent: 'center',
                                        borderColor: quizSubmitted
                                            ? userAnswers[index] === questions[index].answer
                                                ? 'green'
                                                : 'red'
                                            : '#ccc'
                                    }}
                                />
                                {quizSubmitted && (
                                    <Text style={{ color: userAnswers[index] === questions[index].answer ? 'green' : 'red' }}>
                                        {userAnswers[index] === questions[index].answer ? 'Correct' : `Incorrect, correct answer is ${questions[index].answer}`}
                                    </Text>
                                )}
                            </View>
                        )}
                    </Collection>
                    <Button onClick={submitQuiz}>Submit</Button>
                </View>
            )}
        </View>
    );
};

export default ArithmeticPractice;
